import { css } from '@emotion/css';
import { primaryBackground } from '@assets/colors';

export const styDashboardWrapper = css`
  background: ${primaryBackground};
`;

export const styText = css`
  display: block;
  font-size: 14px;
  margin-top: 16px;
`;

export const styBtnWrapper = css`
  display: flex;
  flex-flow: row;
  margin-top: 24px;
  justify-content: space-between;
`;

export const styBtnWidth = css`
  width: 48%;
`;
